import { render, staticRenderFns } from "./QuestAns.vue?vue&type=template&id=67743eb7&scoped=true"
import script from "./QuestAns.vue?vue&type=script&lang=js"
export * from "./QuestAns.vue?vue&type=script&lang=js"
import style0 from "./QuestAns.vue?vue&type=style&index=0&id=67743eb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67743eb7",
  null
  
)

export default component.exports